import axios from "axios";

export default {
    get: (ctrl) => axios.get("/api/add_ins/get", ctrl ? { signal: ctrl.signal } : null),
    getByCategory: (category, ctrl) => axios.get(`/api/add_ins/get_by_category/${category}`, ctrl ? { signal: ctrl.signal } : null),
};
